{
  "auth": {
    "agree": "Acepto",
    "createAccount": "Crear cuenta",
    "createNewAccount": "Crear cuenta nueva",
    "email": "Correo",
    "login": "Iniciar sesión",
    "password": "Contraseña",
    "recover_password": "Recuperar contraseña",
    "sign_up": "Registro de usuario",
    "keep_logged_in": "Mantenerme conectado",
    "termsOfUse": "Acepto términos y condiciones",
    "reset_password": "Restablecer contraseña",
    "dontHaveAccount": "¿No tienes una cuenta?",
    "loginWithGoogle": "Gmail",
    "loginWithFacebook": "Facebook",
    "haveAccount": "¿Tienes una cuenta?",
    "recoverSended": "Si existe una cuenta con ese correo electrónico, recibirás un enlace para restablecer tu contraseña.",
    "operation-not-allowed": "Inicio de sesión no permitido",
    "link": "y condiciones."
  },
  "404": {
    "title": "Esta página se ha ido a pescar",
    "text": "Si crees que esto no es correcto, por favor envíanos un mensaje a ",
    "back_button": "Volver al tablero"
  },
  "typography": {
    "primary": "Estilos de texto primarios",
    "secondary": "Estilos de texto secundarios"
  },
  "dashboard": {
    "versions": "Versiones",
    "setupRemoteConnections": "Configurar conexiones remotas",
    "currentVisitors": "Visitantes actuales",
    "charts": {
      "trendyTrends": "Tendencias modernas",
      "showInMoreDetail": "Mostrar en más detalle",
      "showInLessDetail": "Mostrar en menos detalle",
      "loadingSpeed": "Velocidad de carga",
      "topContributors": "Principales contribuyentes",
      "showNextFive": "Mostrar los siguientes cinco",
      "commits": "Commit"
    },
    "info": {
      "componentRichTheme": "Tema rico en componentes",
      "completedPullRequests": "Solicitudes de pull completadas",
      "users": "Usuarios",
      "points": "Puntos",
      "units": "Unidades",
      "exploreGallery": "Explorar galería",
      "viewLibrary": "Ver biblioteca",
      "commits": "Commits",
      "components": "Componentes",
      "teamMembers": "Miembros del equipo"
    },
    "tabs": {
      "overview": {
        "title": "Visión general",
        "built": "Construido con el framework Vue.js",
        "free": "Totalmente gratuito para todos",
        "fresh": "Diseño fresco y nítido",
        "mobile": "Responsivo y optimizado para móviles",
        "components": "Toneladas de componentes útiles",
        "nojQuery": "Totalmente libre de jQuery"
      },
      "billingAddress": {
        "title": "Dirección de facturación",
        "personalInfo": "Información personal",
        "firstName": "Nombre y apellido",
        "email": "Email",
        "address": "Dirección",
        "companyInfo": "Información de la empresa",
        "city": "Ciudad",
        "country": "País",
        "infiniteConnections": "Conexiones infinitas",
        "addConnection": "Añadir conexión"
      },
      "bankDetails": {
        "title": "Detalles del banco",
        "detailsFields": "Campos de detalles",
        "bankName": "Nombre del banco",
        "accountName": "Nombre de la cuenta",
        "sortCode": "Código de ordenación",
        "accountNumber": "Número de cuenta",
        "notes": "Notas",
        "sendDetails": "Enviar detalles"
      }
    },
    "navigationLayout": "Diseño de navegación",
    "topBarButton": "Barra superior",
    "sideBarButton": "Barra lateral"
  },
  "language": {
    "brazilian_portuguese": "Portugués brasileño",
    "english": "Inglés",
    "spanish": "Español",
    "simplified_chinese": "Chino simplificado",
    "persian": "Persa"
  },
  "menu": {
    "auth": "Autenticación",
    "buttons": "Botones",
    "timelines": "Líneas de tiempo",
    "dashboard": "Inicio",
    "billing": "Facturación",
    "login": "Iniciar sesión",
    "preferences": "Preferencias",
    "payments": "Pagos",
    "pricing-plans": "Planes de precios",
    "login-singup": "Iniciar sesión/Registrarse",
    "404": "Páginas 404",
    "faq": "FAQ",
    "users": "Mis Clientes",
    "products": "Mis Productos",
    "invoices": "Facturación",
    "ventas": "Emitir Comprobante",
    "compras": "Recibir Comprobante",
    "reports": "Reportes",
    "budgets": "Mi ahorro",
    "reminders": "Recordatorios",
    "otherInvoices": "Movimientos Financieros",
    "otherIncomings": "Registrar Ingreso",

    "otherOutcomings": "Registrar Egreso",
    "administration": "Administración",
    "reportsAndAnalysis": "Reportes y Análisis",
    "remindersAndTasks": "Recordatorios y Tareas"
  },
  "messages": {
    "all": "Ver todos los mensajes",
    "new": "Nuevos mensajes de {name}",
    "mark_as_read": "Marcar como leído",
    "userCreated": "Usuario {name} creado correctamente",
    "userUpdated": "Usuario {name} editado correctamente",
    "userDeleted": "Usuario {name} eliminado correctamente",
    "unsavedChanges": "Tienes cambios sin guardar. ¿Seguro quieres cerrar el formulario?",
    "error": "Se produjo un error al guardar la información. Verifica los datos ingresados y vuelve a intentarlo. {detail}",
    "errorDeleteUser": "Se produjo un error al eliminar el usuario. Verifica los datos y vuelve a intentarlo.",
    "productCreated": "Producto {name} creado correctamente",
    "productUpdated": "Producto {name} editado correctamente",
    "productDeleted": "Producto {name} eliminado correctamente",
    "errorDeleteproduct": "Se produjo un error al eliminar el producto. Verifica los datos y vuelve a intentarlo.",
    "invoiceCreated": "Factura creada correctamente",
    "invoiceDeleted": "Eliminado correctamente",
    "errorDeleteInvoice": "Se produjo un error al eliminar la factura",
    "productAlreadyAdded": "Producto seleccionado incorrecto",
    "signatureError": "No pudimos validar tu firma electrónica. Verifícala e inteta de nuevo. ",
    "signatureValidMessage": "Firma válida hasta el {date}",
    "signatureInvalidMessage": "Firma vencida el {date}",
    "settingsSuccess": "Configuración guardada correctamente.",
    "settingsError": "Se produjo un error al guardar las configuraciones.",
    "invoiceError": "No se pudo crear la factura: {message}",
    "passwordRules": "La contraseña debe contener al menos 8 caracteres: letras, números y caracteres especiales",
    "requiredField": "{field} es un campo obligatorio",
    "emailRules": "Ingresa un correo válido",
    "repeatPasswordRules": "Las contraseñas no coinciden",
    "password8Characters": "La contraseña debe contener al menos 8 caracteres",
    "password1letter": "La contraseña debe contener al menos una letra",
    "password1Number": "La contraseña debe contener al menos un número",
    "password1Special": "La contraseña debe contener al menos un caracter especial",
    "incorrectLogin": "Usuario o contraseña incorrectos",
    "forgotPassword": "¿Olvidate tu contraseña?",
    "forgotPasswordDescription": "Si olvidaste tu contraseña, no te preocupes. Solamente ingresa tu correo y te enviaremos un acceso temporal para que puedas recuperar tu cuenta.",
    "incorrectInvoiceLoad": "{invoice} no cumple condiciones. El ruc del comprador ({ruc}) no coincide con el ruc configurado ({rucSettings})",
    "purchasesCreated": "Comprobantes creados correctamente",
    "productPriceOptional": "* Poner 0 para modificar el precio al generar la factura.",
    "noData": "No hay datos disponibles",
    "budgetCreated": "Plan de ahorro creado correctamente.",
    "budgetDeleteError": "Se produjo un error al eliminar el plan de ahorro. {message}",
    "budgetDeleted": "Plan de ahorro eliminado correctamente.",
    "invoiceValidated": "Factura validada correctamente.",
    "errorValidatingInvoice": "Se produjo un error al validar la factura.",
    "reminderCreated": "Recordatorio creado correctamente.",
    "reminderError": "Se produjo un error al crear recordatorio.",
    "reminderDeleted": "Recordatorio eliminado correctamente.",
    "ingresoDeleted": "Ingreso eliminado correctamente.",
    "ingresoUpdated": "Ingreso modificado correctamente.",
    "ingresoCreated": "Ingreso guardado correctamente.",

    "egresoDeleted": "Egreso eliminado correctamente.",
    "gresoUpdated": "Egreso modificado correctamente.",
    "egresoCreated": "Egreso creado correctamente.",

    "reminderDeleteError": "Se produjo un error al eliminar el recordatorio.",
    "registerSuccess": "Enviamos un link de validación a tu correo electrónico.",
    "invoiceSent": "Comprobante enviado correctamente.",
    "errorSendInvoice": "Se produjo un error al enviar el comprobante.",
    "reportNoData": "No hay datos para el reporte seleccionado.",
    "maxAllowedDaysReached": "Selecciona un rango de fechas máximo de 1 año",
    "budgetError": "Se produjo un error al guardar el plan de ahorro.",
    "noteCreated": "Nota guardada correctamente.",
    "noteError": "Se produjo un error al crear la nota. {message}",
    "noteDeleted": "Nota eliminada correctamente.",
    "noteDeleteError": "Se produjo un error al eliminar la nota. {message}",
    "expiredSignature": "Firma expirada el {date}"
  },
  "error": {
    "userNotFound": "Usuario no encontrado",
    "wrongPassword": "Contraseña incorrecta",
    "invalidEmail": "Correo incorrecto",
    "something": "Se produjo algún error, verifica tus datos y vuelve a intentarlo",
    "emailUsed": "Correo ya registrado. Inicia sesión o recupera tu contraseña para continuar",
    "weakPassword": "Contraseña no cumple con los requisitos de seguridad"
  },
  "navbar": {
    "messageUs": "Preguntas sobre desarrollo web:",
    "repository": "Repositorio GitHub"
  },
  "notifications": {
    "all": "Ver todas las notificaciones",
    "mark_as_read": "Marcar como leída",
    "sentMessage": "{name} te envió un mensaje",
    "uploadedZip": "{name} subió un archivo Zip con {type}",
    "startedTopic": "{name} inició un nuevo tema"
  },
  "user": {
    "language": "Cambiar Idioma",
    "logout": "Cerrar sesión",
    "profile": "Mi Perfil",
    "settings": "Configuración",
    "billing": "Facturación",
    "faq": "Preguntas Frecuentes",
    "helpAndSupport": "Ayuda & Soporte",
    "projects": "Proyectos",
    "account": "Cuenta",
    "explore": "Explorar"
  },
  "helpAndSupport": "Ayuda y Soporte",
  "aboutVuesticAdmin": "Acerca de Vuestic Admin",
  "search": {
    "placeholder": "Buscar..."
  },
  "users": {
    "add": "Nuevo Cliente",
    "plural": "Clientes",
    "ruc": "Identificación",
    "fullname": "Razón Social",
    "email": "Correo",
    "address": "Dirección",
    "editUser": "Editar Cliente",
    "deleteTitle": "Eliminar usuario",
    "deleteMessage": "¿Está seguro de eliminar el cliente {name}?",
    "identificationType": "Tipo de identificación",
    "phone": "Teléfono",
    "name": "Nombre",
    "createdAt": "Fecha de creación",
    "license": "Licencia"
  },
  "form": {
    "labels": {
      "save": "Guardar",
      "cancel": "Cancelar",
      "results": "Resultados",
      "resultsPerPage": "Resultados por página",
      "delete": "Eliminar",
      "search": "Buscar",
      "userName": "Nombre de usuario",
      "email": "Correo",
      "password": "Contraseña",
      "passwordRepeat": "Confirmar contraseña",
      "sendPassword": "Enviar contraseña",
      "goBack": "Volver",
      "month": "Mes",
      "resetPassword": "Cambiar contraseña",
      "oldPassword": "Contraseña actual",
      "newPassword": "Contraseña nueva",
      "lastLogin": "Último login",
      "downloadReport": "Descargar reporte",
      "actions": "Acciones",
      "sendMessage": "Escribe un mensaje...",
      "syncWhatsapp": "Sincronizar con Whatsapp",
      "phone": "Celular",
      "chatWhatsapp": "Envía un mensaje por Whatsapp"
    }
  },
  "products": {
    "plural": "Productos",
    "add": "Nuevo Producto",
    "code": "Código",
    "name": "Nombre",
    "price": "Precio",
    "unit": "Unidad de medida",
    "edit": "Editar producto",
    "deleteTitle": "Eliminar product",
    "deleteMessage": "¿Está seguro de eliminar el producto {name}?",
    "tax": "Tarifa IVA(%)",
    "additionalInfo": "Información adicional",
    "iva": "IVA",
    "unitPrice": "Precio unitario",
    "detail": "Detalle"
  },
  "ventas": {
    "plural": "Facturas de Ventas",
    "add": "Registrar Comprobante",
    "date": "Fecha",
    "client": "Cliente",
    "products": "Productos",
    "code": "Código",
    "total": "Total",
    "subtotal": "Subtotal",
    "tax": "Impuestos",
    "discount": "Descuento",
    "cant": "Cantidad",
    "paymentMethod": "Método de pago",
    "additionalName": "Nombre",
    "additionalDescription": "Descripción",
    "additionalFields": "Campos adicionales",
    "status": "Estado",
    "number": "Número",
    "isManual": "No generar factura electrónica",
    "generateInvoice": "¿Generar comprobante electrónico para {name}? Se enviará al SRI para validación.",
    "generateComprobante": "Guardar comprobante de ingreso?",
    "bulkSave": "¿Guardar comprobantes electrónicos?",
    "subtotalTarifaDiferenteCero": "Subtotal tarifa diferente de 0%",
    "subtotalTarifaCero": "Subtotal tarifa 0%",
    "addIncoming": "Registrar Nuevo Ingreso",
    "deleteComprobante": "¿Eliminar comprobante de ingreso?",
    "category": "Categoría",
    "otherIncomings": "Otros Ingresos",
    "ambiente": "Ambiente",
    "comprobanteNotAllowed": "Comprobante no permitido",
    "deleteTitle": "Eliminar comprobante",
    "deleteMessage": "¿Seguro eliminar comprobante electrónico {number}?"
  },
  "settings": {
    "theme": "Color de fondo",
    "dark": "Obscuro",
    "light": "Claro",
    "logo": "Logo emisor",
    "fileUpload": "Carga aquí una imagen del logo de tus comprobantes",
    "signature": "Firma electrónica",
    "signatureUpload": "Carga aquí el archivo en formato .p12 de tu firma electrónica",
    "accountingRequired": "Obligado a llevar contabilidad",
    "other": "Otras configuraciones",
    "passSignature": "Contraseña de la Firma electrónica",
    "recepAdded": "Url de recepción",
    "authoAdded": "Url de Autorización",
    "environment": "Ambiente",
    "signatureSettings": "Configuraciones de firma electrónica",
    "validateSignature": "Validar firma electrónica",
    "rimpe": "Contribuyente RIMPE",
    "popular": "Negocio popular",
    "special": "Contribuyente Especial",
    "razon": "Razón Social",
    "commercialName": "Nombre Comercial",
    "ruc": "Cédula/RUC",
    "establecimiento": "Establecimiento",
    "ptoEmision": "Punto de emisión",
    "address": "Dirección matriz",
    "startInvoiceFrom": "Iniciar factura desde",
    "missingSignature": "Solo falta configurar tu RUC/CI para que empieces a emitir y recibir comprobantes de ingresos/egresos.",
    "signatureNotRequired": "Si aún no tienes firma electrónica, configura solo tu información comercial para que puedas registrar comprobantes de ingreso/egreso sin autorización del SRI.",
    "commercialInfo": "Información comercial",
    "missingElectronicSignature": "Debes configurar tu firma electrónica para emitir comprobantes electrónicos",
    "passwordSRI": "Contraseña SRI",
    "SRISync": "Sincroniza con tu cuenta del SRI",
    "SRIUserError": "No pudimos sincronizar con tu cuenta del SRI. Verifica tus datos y vuelve a intentarlo.",
    "SRIUserNotValid": "Ingresa una cédula o RUC correcto.",
    "SRIUserValidated": "Cuenta sincronizada correctamente.",
    "synchronized": "Sincronizado correctamente",
    "new": "Nueva configuración",
    "deleteTitle": "Eliminar configuración",
    "deleteMessage": "¿Seguro eliminar configuración: {name}?",
    "deleteSuccess": "Configuración eliminada con éxito"
  },
  "compras": {
    "add": "Registrar Comprobante",
    "bulkAdd": "Cargar comprobantes XML",
    "addXMLFilesMessage": "Carga aquí tus facturas en formato XML autorizados por el SRI",
    "cargarArchivos": "Cargar archivos",
    "type": "Tipo comprobante",
    "emisor": "Emisor",
    "total": "Total",
    "date": "Fecha",
    "detail": "Detalle",
    "deleteMessage": "¿Está seguro de eliminar la factura de compra de {emisor}?",
    "tax": "Impuesto",
    "baseImponible": "Base Imponible",
    "documentNumber": "Número de documento",
    "addProduct": "Añadir",
    "subtotalCero": "Subtotal Tarifa 0%",
    "subtotalNoCero": "Subtotal Tarifa Diferente de 0%",
    "discount": "Descuento",
    "details": "Detalles",
    "subtotal": "Subtotal",
    "generateInvoice": "¿Guardar comprobante de compra?",
    "bulkGenerate": "¿Guardar comprobantes de compras?",
    "year": "Año",
    "category": "Categoría",
    "addEgreso": "Registrar Nuevo Egreso",
    "additionalDescription": "Descripción",
    "paymentMethod": "Método de pago",
    "deleteComprobante": "¿Eliminar comprobante de egreso?",
    "generateComprobante": "¿Guardar comprobante de egreso?",
    "other": "Otros egresos",
    "sriReconcile": "Conciliar SRI",
    "sriReconcileHint": "Carga el reporte Recibidos del SRI (.txt). El mismo archivo sirve para facturas, notas de crédito, notas de débito y retenciones: se identifican por la clave de acceso. Solo se listan los que faltan; súbelos desde Comprobantes Recibidos.",
    "sriUploadMessage": "Carga aquí el reporte Recibidos del SRI en formato TXT",
    "sriVerify": "Verificar",
    "sriVerifyError": "No se pudo conciliar el reporte SRI.",
    "sriCounts": "Registros (reporte / sistema)",
    "sriTotals": "Totales (reporte / sistema)",
    "sriKeys": "Claves de acceso",
    "sriMatch": "Igual",
    "sriMismatch": "No coincide",
    "sriMissing": "Faltan en el sistema",
    "sriMissingShort": "faltantes",
    "sriMissingHint": "Sube estos comprobantes desde Comprobantes Recibidos.",
    "sriNoMissing": "Todas las claves del reporte ya están en el sistema.",
    "sriByType": "Resumen por tipo de comprobante",
    "sriReportCount": "Registros reporte",
    "sriSystemCount": "Registros sistema",
    "sriReportTotal": "Total reporte",
    "sriSystemTotal": "Total sistema",
    "sriAccessKey": "Clave de acceso",
    "sriPeriod": "Período del reporte: {from} a {to}",
    "secuencial": "Secuencial"
  },
  "summary": {
    "ganancia": "Saldo del Año",
    "monthlyEarning": "Ahorro Mensual",
    "invoiceTotal": "Total ingresos",
    "purchaseTotal": "Total gastos",
    "providers": "Resumen de compras por proovedor",
    "totalByProduct": "Resumen de compras por productos",
    "totalRetenciones": "Resumen de retenciones recibidas",
    "totalNotasCredito": "Resumen de notas de crédito recibidas",
    "reportType": "Tipo de reporte",
    "dateFrom": "Fecha desde",
    "dateTo": "Fecha hasta",
    "lastMonth": "último mes",
    "topProviders": "Proveedores destacados",
    "topEgresos": "Resumen de egresos",

    "provider": "Proveedor",
    "total": "Total",
    "yearlyPerformance": "Resumen Anual",
    "topCustomers": "Clientes destacados",
    "topProducts": "Productos más comprados",
    "budget": "Mi Objetivo de Ahorro",
    "invoiceByProvider": "Resumen de ventas por proveedor",
    "invoiceByProduct": "Resumen de ventas por productos",
    "gastosPersonales": "Anexo de gastos personales"
  },
  "validations": {
    "strBetween": "{field} debe estar entre {min} y {max} caracteres."
  },
  "budgets": {
    "add": "Nuevo plan de ahorro",
    "total": "Valor",
    "budgetPlan": "Ingresa el valor de tu plan de ahorro anual.",
    "description": "Detalle",
    "budgetDescription": "Ingresa el motivo de tu plan de ahorro anual.",
    "year": "Año",
    "deleteTitle": "¿Eliminar plan de ahorro?",
    "deleteMessage": "¿Está seguro de eliminar el plan de ahorro: {detail}?",
    "current": "Ahorro actual",
    "goal": "Ahorro objetivo",
    "edit": "Editar presupuesto {detail}"
  },
  "reminders": {
    "add": "Nuevo Recordatorio",
    "date": "Fecha",
    "description": "Detalle",
    "reminderDate": "Ingresa la fecha del Recordatorio. Ej. 14/10/2025",
    "reminderDescription": "Ingresa el motivo del recordatorio. Ej. Envío de factura mensual.",
    "deleteTitle": "Eliminar recordatorio",
    "deleteMessage": "¿Está seguro de eliminar el recordatorio: {detail}?",
    "lastNotifications": "Notificaciones pasadas",
    "currentNotifications": "Notificaciones actuales",
    "update": "Actualizar recordatorio {detail}",
    "reminderHour": "Ingresa la hora del Recordatorio. Ej. 09:50",
    "hour": "Hora"
  },
  "notes":{
    "add": "Nueva nota",
    "update": "Editar nota - {detail}",
    "title": "Título",
    "description": "Descripción",
    "titleDescription": "Ingresa el título de tu nota. Ej. Último pago de impuestos.",
    "noteDescription":  "Ingresa la descripción de tu nota. Ej. Último pago de impuesto a la renta en abril por $150.",
    "date": "Fecha",
    "deleteTitle": "Eliminar nota",
    "deleteMessage": "¿Seguro eliminar nota: {detail}?"
  },
  "signature":{
    "type": "Tipo",
    "date": "Fecha",
    "email": "Correo",
    "period": "Período",
    "status": "Estado",
    "identificationNumber": "Identificación",
    "createdAt": "Fecha de solicitud",
    "fingerCode": "Código dactilar",
    "cellphoneNumber": "Celular",
    "province": "Provincia",
    "city": "Ciudad",
    "address": "Dirección",
    "price": "Precio",
    "paymentMethod": "Método de pago",
    "paymentDate": "Fecha de pago",
    "paymentDetail": "Detalle del pago",
    "companyName": "Nombre de la empresa",
    "companyRuc": "RUC de la empresa",
    "position": "Cargo",
    "appointmentExpirationDate": "Expiración nombramiento",
    "birthDate": "Fecha de nacimiento"
  }
}
